import React, { Component, PropTypes } from 'react';

import { getVerificationOptionData, getVerificationOptionAvailability } from 'components/Gbp/gbpHelper';
import LoadingIndicator from 'components/LoadingIndicator';
import { GBP_VERIFICATION_OPTIONS } from 'constants/gbp';

class GbpVerificationOptions extends Component {
    static propTypes = {
        getGbpLocationVerificationOptions: PropTypes.func,
        isLoading: PropTypes.bool,
        locationVerificationMethods: PropTypes.object,
        setSelectedVerficationOption: PropTypes.func,
        locationId: PropTypes.string
    };

    constructor() {
        super();
        this.state = {
            verificationViaPhone: true,
            verificationViaPhoneExpand: true,
            verificationViaEmailExpand: true,
        };
    }

    componentDidMount() {
        const { getGbpLocationVerificationOptions, locationId } = this.props;

        getGbpLocationVerificationOptions(locationId);
    }

    componentDidUpdate({ locationVerificationMethods: prevlocationVerificationMethods }) {
        const { setSelectedVerficationOption } = this.props;

        // If only one standard verification method(SMS/Phone call/Email) is available, set it to selected verification method)
        if (prevlocationVerificationMethods.size === 0 && this.props.locationVerificationMethods.size === 1) {
            const checkStandardOptionsAvailability = (getVerificationOptionAvailability(GBP_VERIFICATION_OPTIONS.SMS, this.props.locationVerificationMethods) ||
                getVerificationOptionAvailability(GBP_VERIFICATION_OPTIONS.PHONE_CALL, this.props.locationVerificationMethods) || getVerificationOptionAvailability(GBP_VERIFICATION_OPTIONS.EMAIL, this.props.locationVerificationMethods));
            if (checkStandardOptionsAvailability) {
                setSelectedVerficationOption(this.props.locationVerificationMethods);
            }
        }
    }

    expandSection = (verificationViaPhone) => {

        this.setState(
            (prevState) => (verificationViaPhone ? { verificationViaPhoneExpand: !prevState.verificationViaPhoneExpand } :
                { verificationViaEmailExpand: !prevState.verificationViaEmailExpand })
        );
    };


    render() {

        const { verificationViaPhone, verificationViaPhoneExpand, verificationViaEmailExpand } = this.state;
        const { isLoading, locationVerificationMethods, setSelectedVerficationOption } = this.props;
        const verifyViaSMS = getVerificationOptionData(GBP_VERIFICATION_OPTIONS.SMS, locationVerificationMethods);
        const verifyViaPhoneCall = getVerificationOptionData(GBP_VERIFICATION_OPTIONS.PHONE_CALL, locationVerificationMethods);
        const verifyViaEmail = getVerificationOptionData(GBP_VERIFICATION_OPTIONS.EMAIL, locationVerificationMethods);
        const verifyViaPhone = verifyViaSMS.concat(verifyViaPhoneCall);
        const isSMS = verifyViaSMS.size > 0;
        const isPhoneCall = verifyViaPhoneCall.size > 0;

        return <div>
            {isLoading ? <div className={'loadmore'}><LoadingIndicator loading={isLoading} /></div> :
                <div>
                    <p>
                        Google needs to verify that you manage this business. Select how you'd like to get a verification code.
                    </p>
                    {verifyViaPhone.size > 0 ?
                        <div className={'accordian-section'}>
                            <div className={'flex accordian-section-head'} onClick={() => this.expandSection(verificationViaPhone)}>
                                <i className='material-icons arrowhead'>{!verificationViaPhoneExpand ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}</i>
                                <h4 className={'full-width'}>Verify via Phone ({verifyViaPhone.get(0).get('phoneNumber')})</h4>
                            </div>

                            <div className={'accordian-section-content'} style={!verificationViaPhoneExpand ? { display: 'none' } : { display: 'block' }}>
                                {(verifyViaEmail.size === 0 && verifyViaPhone.size === 1) ?
                                    <div>
                                        {isSMS ?
                                            <div className={'custom-toggle radio'}>
                                                <input
                                                    type={'radio'}
                                                    id={`11`}
                                                    name={'radio1'}
                                                    defaultChecked={true}
                                                />
                                                <label htmlFor={`11`}>Send Text Message</label>
                                            </div> :
                                            <div className={'custom-toggle radio'}>
                                                <input
                                                    type={'radio'}
                                                    id={`12`}
                                                    name={'radio1'}
                                                    defaultChecked={true}
                                                />
                                                <label htmlFor={`12`}>Call Mobile</label>
                                            </div>
                                        }
                                    </div> :
                                    <div>
                                        {isSMS ?
                                            <div className={'custom-toggle radio'}>
                                                <input
                                                    type={'radio'}
                                                    id={`11`}
                                                    name={'radio1'}
                                                    onChange={() => setSelectedVerficationOption(verifyViaSMS)}
                                                />
                                                <label htmlFor={`11`}>Send Text Message</label>
                                            </div> :
                                            null}
                                        {isPhoneCall ?
                                            <div className={'custom-toggle radio'}>
                                                <input
                                                    type={'radio'}
                                                    id={`12`}
                                                    name={'radio1'}
                                                    onChange={() => setSelectedVerficationOption(verifyViaPhoneCall)}
                                                />
                                                <label htmlFor={`12`}>Call Mobile</label>
                                            </div> :
                                            null}
                                    </div>
                                }
                            </div>
                        </div> : null}
                    {verifyViaEmail.size > 0 ?
                        <div className={'accordian-section'}>
                            <div className={'flex accordian-section-head'} onClick={() => this.expandSection(!verificationViaPhone)}>
                                <i className='material-icons arrowhead'>{!verificationViaEmailExpand ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}</i>
                                <h4 className={'full-width'}>Verify via Email ({verifyViaEmail.get(0).get('emailData')})</h4>
                            </div>

                            <div className={'accordian-section-content'} style={!verificationViaEmailExpand ? { display: 'none' } : { display: 'block' }}>
                                {verifyViaPhone.size === 0 ?
                                    <div className={'custom-toggle radio'}>
                                        <input
                                            type={'radio'}
                                            id={`13`}
                                            name={'radio1'}
                                            defaultChecked={true}
                                        />
                                        <label htmlFor={`13`}>Send Email</label>
                                    </div> :
                                    <div className={'custom-toggle radio'}>
                                        <input
                                            type={'radio'}
                                            id={`13`}
                                            name={'radio1'}
                                            onChange={() => { setSelectedVerficationOption(verifyViaEmail) }}
                                        />
                                        <label htmlFor={`13`}>Send Email</label>
                                    </div>
                                }
                            </div>
                        </div>
                        : null}
                </div>}
        </div>
    }
}

export default GbpVerificationOptions;
